import React, { Component, Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './school-profile.styles'
import Paper from 'pobble-components/dist/paper'
import Spinner from 'pobble-components/dist/spinner'
import SchoolHeader from './school-header/school-header.container'
import SchoolAvatar from './school-avatar/school-avatar.container'
import SchoolCover from './school-cover/school-cover.container'
import SchoolGeneral from './school-general/school-general.container'

class SchoolProfile extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
    this.props.onMount()
  }
  render() {
    const { classes, pending } = this.props
    return (
      <Fragment>
        {!pending && (
          <Paper className={classes.container}>
            <SchoolHeader />
            <SchoolAvatar />
            <SchoolCover />
            <SchoolGeneral />
          </Paper>
        )}
        {pending && <Spinner className={classes.spinner} />}
      </Fragment>
    )
  }
}

export default injectSheet(styles)(SchoolProfile)
